/* CANIPANI — recherche par race dans le guide des tailles.
 *
 * Lefabre publie 120 races et une lettre. Nous publions la longueur du corps,
 * la taille qui en decoule par NOTRE regle, et les centimetres du couchage.
 * Le filtre est insensible aux accents : « epagneul » doit trouver « épagneul ».
 */
(function () {
  var racine = document.querySelector('[data-races]');
  if (!racine) return;

  var champ = racine.querySelector('[data-races-champ]');
  var corps = racine.querySelector('[data-races-corps]');
  var compte = racine.querySelector('[data-races-compte]');
  var vide = racine.querySelector('[data-races-vide]');
  var source = racine.getAttribute('data-races');
  var toutes = [];

  function sansAccent(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function ligne(r) {
    return '<tr><th scope="row">' + r.nom + '</th>' +
      '<td>' + r.lg + ' cm</td>' +
      '<td><strong>' + r.taille + '</strong></td>' +
      '<td>' + r.cm + '</td></tr>';
  }

  function afficher(liste) {
    corps.innerHTML = liste.map(ligne).join('');
    if (compte) {
      compte.textContent = liste.length === 1
        ? '1 race'
        : liste.length + ' races';
    }
    if (vide) vide.hidden = liste.length > 0;
  }

  function filtrer() {
    var q = sansAccent(champ.value.trim());
    afficher(q ? toutes.filter(function (r) { return sansAccent(r.nom).indexOf(q) !== -1; }) : toutes);
  }

  fetch(source)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      toutes = d;
      afficher(toutes);
      racine.removeAttribute('data-chargement');
      if (champ) champ.addEventListener('input', filtrer);
    })
    .catch(function () {
      // en cas d'echec, on laisse le message de repli plutot qu'un tableau vide
      racine.setAttribute('data-erreur', '1');
    });
})();
